import React from 'react';
import './GradientHeader.css';
import logo from '../assets/ioh logo transp.png';

const GradientHeader = () => {
  return (
    <header className="gradient-header">
      <div className="header-content">
        <div className="logo-container">
          <a href="https://iohealth.ai/?nab=0">
            <img src={logo} alt="IO Health Logo" className="company-logo" />
          </a>
        </div>
        <nav className="header-nav">
          <ul className="nav-items">
            <li><a href="https://iohealth.ai/?nab=0" className="nav-link">Home</a></li>
            <li><a href="https://iohealth.ai/about-us-2/" className="nav-link">About Us</a></li>
            <li><a href="https://iohealth.ai/solutions/" className="nav-link">Solutions</a></li>
            <li><a href="https://iohealth.ai/sources/" className="nav-link">Sources</a></li>
          </ul>
        </nav>
        <a href={process.env.REACT_APP_BOOKING_LINK || "https://calendly.com/davidb-ghs/30-min-io-demo"} className="book-call-btn">
          Book a Call
        </a>
      </div>
      <div className="header-wave">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#ffffff" fillOpacity="0.2" d="M0,128L48,122.7C96,117,192,107,288,101.3C384,96,480,96,576,117.3C672,139,768,181,864,181.3C960,181,1056,139,1152,122.7C1248,107,1344,117,1392,122.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>
    </header>
  );
};

export default GradientHeader;